import axios from 'axios';

const apiUrl = import.meta.env.VITE_API_ENDPOINT || 'http://localhost:3333/';

const api = axios.create({
	baseURL: apiUrl,
});

api.interceptors.request.use((config) => {
	const token = localStorage.getItem('token');
	// Only add the header when the token is valid (not empty, null or undefined)
	if (token && token.trim() !== '' && token !== 'null' && token !== 'undefined') {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

// Interceptor that handles 401 (unauthorized) responses
api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			// Automatically remove the invalid token
			localStorage.removeItem('token');
		}
		return Promise.reject(error);
	}
);

export { api, apiUrl };
